export const endShapeDefaultProp = {
  arrow: {
    arrowLength: 10,
    arrowThickness: 6,
  },
  circle: {
    radius: 2,
    fillColor: '#f00',
    strokeColor: '#0ff',
    strokeWidth: 1,
  },
};
